import { Box, Heading, Paragraph, Text } from '@zillow/constellation-10';

import {
  AutoPaySVGComponent,
  CutCheckSVGComponent,
  MagnifyPaperSVGComponent,
  PalmIslandSVGComponent,
  PaymentRentReportingSVGComponent,
  PeaceOfMindSVGComponent,
} from './LandingPageSvgs';

const WhyPayOnline = () => {
  const renderParagraph = ({ IconComponent, header, body }) => {
    return (
      <Box
        css={{
          marginBottom: 'token(spacing.md) !important',
          display: 'flex',
          flexDirection: 'column',
          gap: 'token(spacing.xs)',
          alignItems: 'center',
        }}
      >
        <IconComponent />
        <div>
          <Paragraph textStyle="body-bold">{header}</Paragraph>
          <Text>{body}</Text>
        </div>
      </Box>
    );
  };

  return (
    <Box css={{ textAlign: 'center', padding: '60px 16px !important' }}>
      <Heading
        textStyle="heading-sm"
        level={2}
        css={{ textAlign: 'center', marginBottom: 'token(spacing.md) !important' }}
      >
        Why should I pay rent online?
      </Heading>

      <Box css={{ display: 'grid', gridTemplateColumns: { base: '1fr 1fr', md: 'repeat(3, 1fr)' } }}>
        {renderParagraph({
          IconComponent: AutoPaySVGComponent,

          header: 'Auto-payments',
          body: "Your rent's on time, every time when you choose to auto-pay.",
        })}
        {renderParagraph({
          IconComponent: PalmIslandSVGComponent,
          header: 'Pay from Anywhere',
          body: 'Pay on the go, or schedule your payments ahead of time.',
        })}
        {renderParagraph({
          IconComponent: CutCheckSVGComponent,
          header: 'Freedom from Checks',
          body: 'No more envelopes or stamps either!',
        })}
        {renderParagraph({
          IconComponent: PeaceOfMindSVGComponent,
          header: 'Peace of Mind',
          body: "It's simple to track every payment, so you can rest easy.",
        })}
        {renderParagraph({
          IconComponent: PaymentRentReportingSVGComponent,
          header: 'Boost your credit',
          body: 'Opt into rent reporting to build credit history as you pay rent on time.',
        })}
        {renderParagraph({
          IconComponent: MagnifyPaperSVGComponent,
          header: 'Clarity',
          body: "You and your landlord always see the same info, so it's " + 'easy to avoid mixups.',
        })}
      </Box>
    </Box>
  );
};

export default WhyPayOnline;
